export default __webpack_public_path__ + "static/women-bodymap-underarms-e09d07518468091563b46b76722d5606.webp";